import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import FreemiumFilterBadge from '@/components/filter-bar/FreemiumFilterBadge.vue';
import { ProModal } from '@/lazy-load-components';

import { SortingItem } from '@/helpers/list-sorting-helper';
import { ModalHelper } from '@/helpers/modal-helper';
import { saveLastProView } from '@/helpers/pro-web-helper';

import { useListSortingStore, useUserStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleListSortingSwitchPopover',
  setup(__props) {

const { setSorting, selectedItem, sortingItems } = useListSortingStore();
const { isPremium } = useUserStore();

const showItems = computed(() => {
	if (!isPremium.value) {
		return sortingItems.value.filter(item => !item.premium);
	}
	return sortingItems.value;
});

function openPremiumModal() {
	ModalHelper.openModal(ProModal, {}, {}, 'SortRuntime', true);
	saveLastProView('SortRuntime');
}

async function changeSorting(item: SortingItem) {
	const { popoverController } = await import('@/ionic.loader');
	popoverController.dismiss();
	if (item.premium && !isPremium.value) {
		openPremiumModal();
	} else {
		setSorting({ sortBy: item.key, sortAsc: item.asc });
	}
}

return { __sfc: true,setSorting, selectedItem, sortingItems, isPremium, showItems, openPremiumModal, changeSorting, FreemiumFilterBadge }
}

})